module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('cookie-law', {
    attrs: {
      "theme": "dark-lime",
      "buttonText": "Ok",
      "storageName": "rem3rch:accepted",
      "storageType": "cookies"
    }
  }, [_c('div', {
    slot: "message"
  }, [_vm._v("\n        We use cookies to ensure that we give you the best experience on our website. If you continue without changing your settings, we'll assume\n        that you are happy to receive cookies on the REM3RCH website. However, you can change your cookie settings at any time.\n        "), _c('a', {
    staticClass: "rgpd_link",
    attrs: {
      "href": "https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser",
      "target": "_blank"
    }
  }, [_vm._v("Find Out More")])]), _vm._v(" "), _c('div', {
    slot: "buttonText"
  }, [_vm._v("Ok")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49aecf94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Cookie.vue
// module id = 3161
// module chunks = 0